import { getTranslation } from '@klauswuestefeld/jux-web';
import { appraisalSubheader } from './appraisal-subheader';
export const blankPage = (msg) => {
    const result = document.createElement('blank-page');
    const container = document.createElement('msg-container');
    container.textContent = getTranslation(msg);
    result.append(appraisalSubheader(), container);
    return result;
};
